/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_6cda7fee","_6cda7fee",""]'><div :class='["multi-picker-wrapper","_6cda7fee",""]'><div :class='["picker-demo-title","_6cda7fee",""]'>multi-picker:</div><cube-picker :list="(dataList)" :selected-index="(selectedIndex)" @columnChange='(e)=>__invoke(e, [["onColumnChange"]])' @change='(e)=>__invoke(e, [["onChange"]])' :class='["","_6cda7fee",""]'/><div :class='["event-params","_6cda7fee",""]' v-if="(changeParams.length)"><div :class='["key","_6cda7fee",""]'>columnChange 事件参数：</div><div :class='["value","_6cda7fee",""]'><div v-for="(item, index) in (columnChangeParams)" :key="item.index" :class='["value-item","_6cda7fee",""]'><div :class='["item-key","_6cda7fee",""]'>{{item[0]}}</div><div :class='["item-value","_6cda7fee",""]'>{{item[1]}}</div></div></div><div :class='["key","_6cda7fee",""]'>change 事件参数：</div><div :class='["value","_6cda7fee",""]'><div v-for="(item, index) in (changeParams)" :key="item.index" :class='["value-item","_6cda7fee",""]'><div :class='["item-key","_6cda7fee",""]'>{{item[0]}}</div><div :class='["item-value","_6cda7fee",""]'>{{item[1]}}</div></div></div></div></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"scoped":true,"mid":"_6cda7fee"}'>
.picker-demo-title
  margin-bottom: 8px
.event-params,
.demo-data
  margin-top: 10px
  padding: 10px 10px
  background-color: white
  border: 1px solid  white
  border-radius: 10px

.key
  margin-bottom: 10px
  font-size: 16px
.key-introduce
  margin-bottom: 10px
  line-height: 20px
.value
  margin-bottom: 20px
  white-space: break-spaces
  .value-item
    display flex
    justify-content: space-between
    height: 25px
    line-height: 25px
    font-size: 15px
    .item-value
      white-space nowrap
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_6cda7fee"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_6cda7fee"}
  /** script content **/
  require("./multi-picker.mpx.js?isComponent&outputPath=components%2Fmulti-picker6cda7fee%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./multi-picker.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fmulti-picker6cda7fee%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_6cda7fee"],
    ctorType: "component",
    outputPath: "components/multi-picker6cda7fee/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-picker':getComponent(require("../../../packages/mpx-cube-ui/src/components/picker/index.mpx?isComponent&outputPath=components%2Findex3b508115%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>